/* eslint-disable */
import { Suspense } from 'react';
import { Loading } from '../../../components/Loading';
import { SearchList } from './SearchList';

export const Search: React.FC<{ id: string }> = () => {
	return (
		<div className="menu menu-menu">
			<Suspense fallback={<Loading />}>
				<SearchList />
			</Suspense>
		</div>
	);
};
